<template>
  <div class="tw-bg-gray-100 tw-h-auto">
    <AppBar />
    <div class="tw-mt-12 tw-ml-14 tw-text-6xl tw-font-bold">Privacy Policy</div>
    <v-card class="tw-ml-10 tw-mr-10 tw-mt-10 tw-justify-normal tw-h-auto">
      <v-card-text class="tw-ml-10 tw-mr-10 tw-mt-10 tw-text-gray-500 tw-mb-10">
        <div class="tw-text-1xl tw-font-bold">
          What personal information do we collect when you use our Services?
        </div>
        <p class="tw-text-1xl tw-mt-4">
          <span class="tw-font-bold">Information you provide us:</span> We
          collect information from you when you register for a trial or purchase
          a Web Service Subscription. You will be asked to enter your name,
          email address, mailing address business name and website domain name
          if applicable. Your credit card information will be collected when
          purchasing a Subscription.
        </p>
        <p class="tw-font-bold tw-text-1xl tw-mt-4">
          How do we use your information?
        </p>
        <p class="tw-text-1xl tw-mt-4">
          We use the information we collect from you in various ways, including:
        </p>
        <ul class="tw-list-disc tw-pl-12 tw-mt-4">
          <li>To allow us to respond to your customer service requests.</li>
          <li>To quickly process your transactions.</li>
          <li>
            To manage and verify your account and the identity as a user of the
            Services.
          </li>
          <li>
            To contact you when necessary about your account or your use of the
            Services.
          </li>
          <li>To send you information about our products and Services.</li>
        </ul>

        <p class="tw-text-1xl tw-mt-4">
          We will retain your information for as long as your subscription is
          active, or as needed to provide you Services. If you wish to cancel
          your subscription or request that we no longer use your information to
          provide you information about our Services, contact us at
          customersupport@greenmedicineworks.com
        </p>

        <p class="tw-font-bold tw-text-1xl tw-mt-4">
          How do we share your information?
        </p>
        <ul class="tw-list-disc tw-pl-12 tw-mt-4">
          <li class="tw-underline">
            We do not share or sell your information.
          </li>
        </ul>
        <p class="tw-font-bold tw-text-1xl tw-mt-4">
          How do we protect your information?
        </p>
        <p class="tw-text-1xl tw-mt-4">
          We implement a variety of security measures to maintain the safety of
          your personal information.
        </p>
        <ul class="tw-list-disc tw-pl-12 tw-mt-4">
          <li>
            Our website is scanned on a regular basis for security holes and
            known vulnerabilities. All personal information you supply is
            encrypted during transmission via Secure Socket Layer (SSL)
            technology.
          </li>
          <li>
            All payment card transactions are processed through an encrypted
            gateway provider and are not stored or processed on our server.
          </li>
        </ul>

        <p class="tw-font-bold tw-text-1xl tw-mt-4">
          Changes to this Privacy Policy
        </p>
        <ul class="tw-list-disc tw-pl-12 tw-mt-4">
          <li>
            We may change this Privacy Policy from time to time. If we decide to
            make a material change in our Privacy Policy, we will post it on
            this page. Your continued use of the Services after the posting of
            changes to this Privacy Policy will mean you accept these changes.
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
  <Footer />
</template>

<script setup lang="ts">
import { useSeo } from "@/composables/useSeo";

useSeo({
  title: "Privacy Policy",
});
</script>

<route lang="yaml">
meta:
  layout: non-auth.vue
</route>
